<template>
    <div 
		@dragenter.prevent="dragOn = true"
		@dragleave.prevent="dragOn = false"
		@dragend.prevent="dragOn = false"
		@dragexit.prevent="dragOn = false"
		@dragover.prevent="dragOn = true"
		@drop.prevent="addFile"
		class="rp-messenger-content__conversation"
		>
        <div
			
			@scroll="handleScroll"
			class="rp-messenger-conversation-messages"
			:class="{
				'dragon': dragOn,
				'closed-conversation': conversationStatus === 'CLOSED'
			}"
			ref="messagesScroller">
			<div v-if="isLoading" v-loading="isLoading" class="rp-messenger-conversation-messages__loading" element-loading-background="rgba(0, 0, 0, 0)"></div>
			<div v-else-if="!messagesList.length" class="rp-messenger-conversation-messages__no-mesasges">
				<Title
					class="rp-messenger-conversation-messages__no-mesasges__title"
					>
					{{ $t('homeScreen.startConversation') }}
				</Title>
				<Subtitle 
					class="rp-messenger-conversation-messages__no-mesasges__sub-title">
					{{ $t('homeScreen.haveAQuestion') }}
				</Subtitle>
			</div>
			<div
				v-else
				class="rp-messenger-conversation-messages-container">
				<div class="rp-messenger-conversation-messages-list">
					<TextMessage
						@submit="$emit('submit', $event)"
						@pickOption="$emit('pickOption', $event)"
						v-for="message in messagesList"
						:key="message.id"
						:message="message"/>
					<UserTyping
						v-if="isUserTyping"
						:typingUserId="typingUserId"
						:backgroundColor="backgroundColor"
					/>
				</div>
			</div>
		</div>
		<div v-if="dragOn" class="rp-files-drag-preview">
			<i class="el-icon-upload" />
			Drop to upload files
		</div>
		<template v-if="dragOn==false">
			<div class="rp-conversation-content-footer-powered-by animated fast fadeInUp"
				:class="{
					'dragon': dragOn,
					'conversation-closed': conversationStatus === 'CLOSED',
				}"
			>
				<PoweredBy 
					class="rp-powered-by"
					:getPoweredByURL="getPoweredByURL" 
				/>
			</div>
			<div class="rp-messenger-reply-input-box closed-conversation"
				v-if="conversationStatus === 'CLOSED'"
				>
				<div  class="hint-text">
					{{$t('homeScreen.conversationClosed')}}
				</div>
				<StartConversationButton
					:style="{ 
						width:'100%'
					}"
					:label="$t('homeScreen.reOpenConversation')"
					@click="changeStatusOfConversation"
				/>
			</div>
			<ReplyInput
				v-else
				@onTyping="handleOnTyping"
				@onEnterNewMessage="handleOnEnterNewMessage"
				/>
		</template>
		
		
    </div>
</template>

<script>
import TextMessage from './TextMessage/';
import UserTyping from './UserTyping';
import ReplyInput from './ReplyInput/';
import { mapActions, mapGetters } from 'vuex';
import MessengerEventBus from '../MessengerEventBus'
import StartConversationButton from './StartConversationButton'
import PoweredBy from '../shared/PoweredBy'
export default {
	
	components: {
		TextMessage,
		ReplyInput,
		UserTyping,
		StartConversationButton,
		PoweredBy
	},
	data() {
		return {
			headerOpen: false,
			dragOn: false,
		}
	},
	
	props: {
		isLoading: {
			type: Boolean,
			default: false
		},
		
		messages: {
			type: Array,
			required: true
		},

		isUserTyping: {
			type: Boolean,
			default: false
		},
		typingUserId: {
			type: String,
			default: false
		},
		backgroundColor: {
			type: String,
			default: false
		},
		conversationStatus: {
			type: String,
			default: "OPEN",
		},

		getPoweredByURL: {
			type: String,
			required: true,
		}

	},

	watch: {
		headerOpen(n, o) {
			//console.log("headerOpen : ", n)
		},

		isUserTyping() {
			this.scrollMessagesContainer();
		},

		messages(newVal, oldVal) {
			this.checkWhetherAssigneeCahnge()
			if (newVal.length > oldVal.length) {
				this.$nextTick(() => {
					this.scrollMessagesContainer();
				});
			}
		},

		isLoading(newVal, oldVal) {
			if(!newVal && oldVal) {
				this.$nextTick(() => {
					this.scrollMessagesContainer();
				});
			}
		}

	},
	computed: {

		...mapGetters({
			agentList: 'agentList',
			selectedConversation: 'selectedConversation',
			getUserAndTeam: 'getUserAndTeam',
			getMembersOfATeam: 'getMembersOfATeam',
		}),

		messagesList(){
			let msg = []

			//editing message to show time only in last message.
			msg = this.messages.map((m,index) => {
				if(index <= this.messages.length-1){
					if(index === this.messages.length-1)
						m.displayImage = true;
					else if(m.senderId === this.messages[index + 1].senderId)
						m.displayImage = false;
					else 
						m.displayImage = true

					if(m.options && m.options.length) {
						m.displayImage = true;
					}
				}
				return m
			})
			return msg
		},
	},
	mounted() {
		window.addEventListener("wheel", this.handleWheelEvent)
		window.addEventListener("touchmove", this.handleTouchmoveEvent, {passive: false})
		MessengerEventBus.$on('SCROLL_TO_BOTTOM', this.scrollMessagesContainer);
	},
	beforeDestroy() {
		MessengerEventBus.$off('SCROLL_TO_BOTTOM', this.scrollMessagesContainer);
	},
	methods: {

		...mapActions({
			SET_SELECTED_CONVERSATION:'SET_SELECTED_CONVERSATION',
			
		}),
		handleWheelEvent(e) {
			this.isHeaderOpen = (e.deltaY < 0 ) ? true : false
			this.$emit('onScroll', this.isHeaderOpen);
		},
		handleTouchmoveEvent(e) {
			e.prevent.default()
			event.stopPropagation();
			console.log("handleTouchmoveEvent", e)
			this.isHeaderOpen = (e.deltaY < 0 ) ? true : false
			this.$emit('onScroll', this.isHeaderOpen);
		},

		checkWhetherAssigneeCahnge(){

		},
		changeStatusOfConversation() {
			this.$emit('changeStatusOfConversation', { status: 'OPEN' })
		},

		handleScroll(e) {
			///this.$emit('onScroll', e);
		},

		handleOnEnterNewMessage(text) {
			this.$emit('onEnterNewMessage', text)
		},

		handleOnTyping(val) {
			this.$emit('onTyping', val)
		},

		scrollMessagesContainer() {
			const container = this.$refs.messagesScroller;
			if (container) {
				const scrollHeight = container.scrollHeight;
				const clientHeight = container.clientHeight;
				if (scrollHeight > clientHeight) {
					this.$nextTick(() => {
						container.scrollTop = scrollHeight;
					})
				}
			}
		},

		addFile(e) {
			let files = e.dataTransfer.files;
			if(!files) return;
			const filteredFiles = Array.from(files).filter((file) => {
				const { size, name } = file;
				if (size > 50 * 1024 * 1024 ) {
					console.error('File size should be less than 50mb '+name);
					return false;
				};
				return true
			})
			for(let file of filteredFiles) {
				this.$emit('onEnterNewMessage', { type: 'file', value: file })
			}
			this.dragOn = false;
		},

	}
}
</script>

<style lang="scss">

.rp-messenger-content__conversation {
	@include chromeBugFix;
	
	//flex-basis: 90%;
	display: flex;
	position: relative;
}

.rp-messenger-conversation-messages {
	flex: 1;
	padding: 20px;
	margin-bottom: 87px;
	overflow: auto;
	background: #fff;
	&.closed-conversation {
		margin-bottom: 150px;
	}
	&.dragon {
		opacity: 0.12
	}
	&.no-messages {
		opacity: 0.12;
	}
	.rp-messenger-conversation-messages__loading {
		height: calc(100% + 70px);
	}
	.rp-messenger-conversation-messages__no-mesasges {
		height: 100%;
		text-align: center;
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: center;
		.rp-messenger-conversation-messages__no-mesasges__title {
			font-size: 2rem;
			color: #666;
			font-weight: 400;
		}
		.rp-messenger-conversation-messages__no-mesasges__sub-title {
			font-size: 19px;
			color: #666;
		}
	}
}

.rp-files-drag-preview {
	text-align: center;
	position: absolute;
	top: 35%;
	width: 100%;
	font-size: 20px;
	font-weight: 500;
	.el-icon-upload {
		display: block;
		font-size: 60px;
	}
}
.rp-conversation-content-footer-powered-by{
	position: absolute;
	bottom: 54px;
	left: 0;
	right: 0;
	margin-left: auto;
	margin-right: auto;
	&.conversation-closed {
		bottom: 0px;
		.rp-powered-by {
			padding: 0px;
			padding-bottom: 3px;
		}
	}
	.rp-powered-by{
		border-bottom-left-radius: 10px;
    	border-bottom-right-radius: 10px;
		display: flex;
		font-size: 12px;
		font-weight:500;
		align-items: center;
		justify-content: center; 
		padding: 5px 0;
		background: #ffffff;
		
		.text{
			margin-right:5px;
		}
	}
}

</style>
